import { render, staticRenderFns } from "./ConfigCtn.vue?vue&type=template&id=c13c4dfc&scoped=true"
import script from "./ConfigCtn.vue?vue&type=script&lang=js"
export * from "./ConfigCtn.vue?vue&type=script&lang=js"
import style0 from "./ConfigCtn.vue?vue&type=style&index=0&id=c13c4dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13c4dfc",
  null
  
)

export default component.exports